import React, {type ReactNode} from 'react';

import cs from 'classnames';

interface DashboardListWidgetProps {
  icon: string;
  title: string;
  children: ReactNode;
}

export function BaseListWidget({
  icon,
  title,
  children,
}: DashboardListWidgetProps) {
  return (
    <div className="card border-0">
      <div className="card-header bg-transparent border-0">
        <h5 className="font-weight-bold">
          <i className={cs(icon, 'mr-1')} /> {title}
        </h5>
      </div>
      <div className="card-body border border-light rounded">{children}</div>
    </div>
  );
}
